import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Question } from "models";

export const useUpdateQuestionMutation = () =>
  useTypedMutation<Question, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/questions/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: payload => {
      const tags = typedQueryClient.getQueryData(QuestionsDashboardQueryKeys.tags)?.filter(tag => payload.tag_ids?.includes(tag.id));
      const queryKey = payload.dealer_id ? QuestionsDashboardQueryKeys.dealerQuestions(payload.dealer_id) : QuestionsDashboardQueryKeys.defaultQuestions;
      const questions = typedQueryClient.getQueryData(queryKey);
      const questionIdx = questions?.findIndex(question => question.id === payload.id) ?? -1;
      if (!questions || questionIdx === -1) return;

      typedQueryClient.setQueryData(queryKey, questions.with(questionIdx, { ...questions[questionIdx], ...payload, tags: tags ?? payload.tags }));
    }
  });
